/******************************************************************************
 * FILE:
 * src/modules/expenseManagement/workflow/components/ApprovalMatrixForm.jsx
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Approval Matrix
 *
 * PURPOSE:
 * Approval Matrix Create / Edit Form
 *
 * ARCHITECTURE
 * • Bootstrap/AdminLTE
 * • Controlled Component
 * • No Business Logic
 * • No API Calls
 ******************************************************************************/

import React from "react";

export default function ApprovalMatrixForm({

    formData,

    errors = {},

    workflows = [],

    workflowTypes = [],

    departments = [],

    locations = [],

    expensePolicies = [],

    expenseCategories = [],

    expenseTypes = [],

    currencies = [],

    designations = [],

    employees = [],

    approvalLevels = [],

    loading = false,

    saving = false,

    onChange,

    onSubmit,

    onCancel,

}) {

    const handleChange = (event) => {

        const {

            name,

            value,

            type,

            checked,

        } = event.target;

        onChange(

            name,

            type === "checkbox"

                ? checked

                : value

        );

    };

    return (

        <form onSubmit={onSubmit}>

            {/* ====================================================== */}
            {/* RULE INFORMATION */}
            {/* ====================================================== */}

            <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Rule Information

                    </strong>

                </div>

                <div className="card-body">

                    <div className="row">

                        {/* Workflow Type */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Workflow Type

                            </label>

                            <select

                                name="workflow_type"

                                className="form-control"

                                value={formData.workflow_type || ""}

                                onChange={handleChange}

                                disabled={loading || saving}

                            >

                                <option value="">

                                    Select Workflow Type

                                </option>

                                {workflowTypes.map((item) => (

                                    <option

                                        key={item.value}

                                        value={item.value}

                                    >

                                        {item.label}

                                    </option>

                                ))}

                            </select>

                        </div>

                        {/* Workflow */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Approval Workflow

                                <span className="text-danger">

                                    *

                                </span>

                            </label>

                            <select

                                name="workflow_id"

                                className={`form-control ${

                                    errors.workflow_id

                                        ? "is-invalid"

                                        : ""

                                }`}

                                value={formData.workflow_id || ""}

                                onChange={handleChange}

                                disabled={loading || saving}

                            >

                                <option value="">

                                    Select Workflow

                                </option>

                                {workflows.map((item) => (

                                    <option

                                        key={item.workflow_id}

                                        value={item.workflow_id}

                                    >

                                        {item.name}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                    <div className="row">

                        {/* Department */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Department

                            </label>

                            <select

                                name="department_id"

                                className="form-control"

                                value={formData.department_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Departments

                                </option>

                                {departments.map((item) => (

                                    <option

                                        key={item.value}

                                        value={item.value}

                                    >

                                        {item.label}

                                    </option>

                                ))}

                            </select>

                        </div>

                        {/* Location */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Location

                            </label>

                            <select

                                name="location_id"

                                className="form-control"

                                value={formData.location_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Locations

                                </option>

                                {locations.map((item) => (

                                    <option

                                        key={item.value}

                                        value={item.value}

                                    >

                                        {item.label}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* EXPENSE CRITERIA */}
            {/* ====================================================== */}

            <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Expense Criteria

                    </strong>

                </div>

                <div className="card-body">

                    <div className="row">

                        {/* Expense Policy */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Expense Policy

                            </label>

                            <select

                                name="expense_policy_id"

                                className="form-control"

                                value={formData.expense_policy_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Policies

                                </option>

                                {expensePolicies.map((item) => (

                                    <option

                                        key={item.expense_policy_id}

                                        value={item.expense_policy_id}

                                    >

                                        {item.name}

                                    </option>

                                ))}

                            </select>

                        </div>

                        {/* Expense Category */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Expense Category

                            </label>

                            <select

                                name="expense_category_id"

                                className="form-control"

                                value={formData.expense_category_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Categories

                                </option>

                                {expenseCategories.map((item) => (

                                    <option

                                        key={item.expense_category_id}

                                        value={item.expense_category_id}

                                    >

                                        {item.name}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                    <div className="row">

                        {/* Expense Type */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Expense Type

                            </label>

                            <select

                                name="expense_type_id"

                                className="form-control"

                                value={formData.expense_type_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Expense Types

                                </option>

                                {expenseTypes.map((item) => (

                                    <option

                                        key={item.expense_type_id}

                                        value={item.expense_type_id}

                                    >

                                        {item.name}

                                    </option>

                                ))}

                            </select>

                        </div>

                        {/* Currency */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Currency

                            </label>

                            <select

                                name="currency_id"

                                className="form-control"

                                value={formData.currency_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Currencies

                                </option>

                                {currencies.map((item) => (

                                    <option

                                        key={item.currency_id}

                                        value={item.currency_id}

                                    >

                                        {item.name}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* EMPLOYEE CRITERIA */}
            {/* ====================================================== */}
                        <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Employee Criteria

                    </strong>

                </div>

                <div className="card-body">

                    <div className="row">

                        {/* Designation */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Designation

                            </label>

                            <select

                                name="designation_id"

                                className="form-control"

                                value={formData.designation_id || ""}

                                onChange={handleChange}

                            >

                                <option value="">

                                    All Designations

                                </option>

                                {designations.map((item) => (

                                    <option

                                        key={item.value}

                                        value={item.value}

                                    >

                                        {item.label}

                                    </option>

                                ))}

                            </select>

                        </div>

                        {/* Employee Scope */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Employee Scope

                            </label>

                            <div className="mt-2">

                                <div className="form-check form-check-inline">

                                    <input

                                        className="form-check-input"

                                        type="radio"

                                        name="employee_scope"

                                        value="ALL"

                                        checked={
                                            (
                                                formData.employee_scope ||
                                                "ALL"
                                            ) === "ALL"
                                        }

                                        onChange={handleChange}

                                    />

                                    <label className="form-check-label">

                                        All Employees

                                    </label>

                                </div>

                                <div className="form-check form-check-inline">

                                    <input

                                        className="form-check-input"

                                        type="radio"

                                        name="employee_scope"

                                        value="SPECIFIC"

                                        checked={
                                            formData.employee_scope ===
                                            "SPECIFIC"
                                        }

                                        onChange={handleChange}

                                    />

                                    <label className="form-check-label">

                                        Specific Employee

                                    </label>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className="row">

                        {/* Employee */}

                        <div className="col-md-12 mb-3">

                            <label className="form-label">

                                Employee

                            </label>

                            <select

                                name="employee_id"

                                className="form-control"

                                value={formData.employee_id || ""}

                                onChange={handleChange}

                                disabled={
                                    (
                                        formData.employee_scope ||
                                        "ALL"
                                    ) !== "SPECIFIC"
                                }

                            >

                                <option value="">

                                    Select Employee

                                </option>

                                {employees.map((item) => (

                                    <option

                                        key={item.value}

                                        value={item.value}

                                    >

                                        {item.label}

                                    </option>

                                ))}

                            </select>

                        </div>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* AMOUNT CRITERIA */}
            {/* ====================================================== */}

            <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Amount Criteria

                    </strong>

                </div>

                <div className="card-body">

                    <div className="row">

                        {/* Minimum Amount */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Minimum Amount

                            </label>

                            <input

                                type="number"

                                step="0.01"

                                name="minimum_amount"

                                className={`form-control ${
                                    errors.minimum_amount
                                        ? "is-invalid"
                                        : ""
                                }`}

                                value={
                                    formData.minimum_amount || ""
                                }

                                onChange={handleChange}

                            />

                            {errors.minimum_amount && (

                                <div className="invalid-feedback">

                                    {errors.minimum_amount}

                                </div>

                            )}

                        </div>

                        {/* Maximum Amount */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Maximum Amount

                            </label>

                            <input

                                type="number"

                                step="0.01"

                                name="maximum_amount"

                                className={`form-control ${
                                    errors.maximum_amount
                                        ? "is-invalid"
                                        : ""
                                }`}

                                value={
                                    formData.maximum_amount || ""
                                }

                                onChange={handleChange}

                            />

                            {errors.maximum_amount && (

                                <div className="invalid-feedback">

                                    {errors.maximum_amount}

                                </div>

                            )}

                        </div>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* RULE CONFIGURATION */}
            {/* ====================================================== */}
                        <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Rule Configuration

                    </strong>

                </div>

                <div className="card-body">

                    <div className="row">

                        {/* Approval Level */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Approval Level

                                <span className="text-danger">*</span>

                            </label>

                            <select

                                name="approval_level_id"

                                className={`form-control ${
                                    errors.approval_level_id
                                        ? "is-invalid"
                                        : ""
                                }`}

                                value={
                                    formData.approval_level_id || ""
                                }

                                onChange={handleChange}

                                disabled={loading || saving}

                            >

                                <option value="">

                                    Select Approval Level

                                </option>

                                {approvalLevels.map((item) => (

                                    <option

                                        key={item.approval_level_id}

                                        value={item.approval_level_id}

                                    >

                                        {item.name}

                                    </option>

                                ))}

                            </select>

                            {errors.approval_level_id && (

                                <div className="invalid-feedback">

                                    {errors.approval_level_id}

                                </div>

                            )}

                        </div>

                        {/* Priority */}

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Priority

                            </label>

                            <input

                                type="number"

                                min="1"

                                name="priority"

                                className={`form-control ${
                                    errors.priority
                                        ? "is-invalid"
                                        : ""
                                }`}

                                value={
                                    formData.priority || 1
                                }

                                onChange={handleChange}

                            />

                            {errors.priority && (

                                <div className="invalid-feedback">

                                    {errors.priority}

                                </div>

                            )}

                        </div>

                    </div>

                    <div className="row">

                        {/* Default Rule */}

                        <div className="col-md-6">

                            <div className="form-check mt-2">

                                <input

                                    id="is_default"

                                    name="is_default"

                                    type="checkbox"

                                    className="form-check-input"

                                    checked={
                                        Boolean(
                                            formData.is_default
                                        )
                                    }

                                    onChange={handleChange}

                                />

                                <label

                                    htmlFor="is_default"

                                    className="form-check-label"

                                >

                                    Default Rule

                                </label>

                            </div>

                        </div>

                        {/* Active */}

                        <div className="col-md-6">

                            <div className="form-check mt-2">

                                <input

                                    id="is_active"

                                    name="is_active"

                                    type="checkbox"

                                    className="form-check-input"

                                    checked={
                                        Boolean(
                                            formData.is_active
                                        )
                                    }

                                    onChange={handleChange}

                                />

                                <label

                                    htmlFor="is_active"

                                    className="form-check-label"

                                >

                                    Active

                                </label>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* VALIDITY */}
            {/* ====================================================== */}

            <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Validity

                    </strong>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Effective From

                            </label>

                            <input

                                type="date"

                                name="effective_from"

                                className="form-control"

                                value={
                                    formData.effective_from || ""
                                }

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Effective To

                            </label>

                            <input

                                type="date"

                                name="effective_to"

                                className="form-control"

                                value={
                                    formData.effective_to || ""
                                }

                                onChange={handleChange}

                            />

                        </div>

                    </div>

                </div>

            </div>

            {/* ====================================================== */}
            {/* ADDITIONAL INFORMATION */}
            {/* ====================================================== */}

            <div className="card mb-3">

                <div className="card-header">

                    <strong>

                        Additional Information

                    </strong>

                </div>

                <div className="card-body">

                    <div className="mb-3">

                        <label className="form-label">

                            Remarks

                        </label>

                        <textarea

                            rows="4"

                            name="remarks"

                            className={`form-control ${
                                errors.remarks
                                    ? "is-invalid"
                                    : ""
                            }`}

                            value={
                                formData.remarks || ""
                            }

                            onChange={handleChange}

                        />

                        {errors.remarks && (

                            <div className="invalid-feedback">

                                {errors.remarks}

                            </div>

                        )}

                    </div>

                </div>

            </div>

            <hr />

            <div className="d-flex justify-content-end">

                <button

                    type="button"

                    className="btn btn-secondary me-2"

                    onClick={onCancel}

                    disabled={saving}

                >

                    Cancel

                </button>

                <button

                    type="submit"

                    className="btn btn-primary"

                    disabled={
                        loading || saving
                    }

                >

                    {saving
                        ? "Saving..."
                        : "Save Rule"}

                </button>

            </div>

        </form>

    );

}